import { render, staticRenderFns } from "./ProblemDefinition.vue?vue&type=template&id=f6fab224"
import script from "./ProblemDefinition.vue?vue&type=script&lang=js"
export * from "./ProblemDefinition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports